import { NotificationManager } from './notify';

/**
 * Wat er op het scherm komt als een aanroep mislukt.
 *
 * Er zijn twee soorten misgaan, en die zagen er tot nu toe hetzelfde uit — namelijk als
 * niets. Een verlopen sessie hoort naar het inlogscherm te leiden; een haperende
 * verbinding hoort dat juist níét te doen, want er is niets mis met wie je bent. Dat
 * laatste gebeurde wel: elke mislukte aanroep zette je op het inlogscherm, zonder een
 * woord, midden op een toernooiavond met wisselvallige kroegwifi.
 *
 * De server geeft bij een verlopen sessie een tekst (zie UserModule.checkIfAuthorized);
 * een netwerkfout komt hier binnen als een Error-object. Dat verschil is het enige dat
 * we nodig hebben — en meteen de reden dat er eerst niets te zien was: een Error-object
 * doorgeven aan de meldingenlaag levert een lege melding op.
 */
export const SESSIE_VERLOPEN = 'Uw sessie is verlopen';

export function meldFout(fout, history) {
    if (isSessieVerlopen(fout)) {
        NotificationManager.error('Je sessie is verlopen. Log opnieuw in.', 4000);

        if (history) {
            history.push('/login');
        }

        return;
    }

    NotificationManager.error(tekstVan(fout), 5000);
}

function isSessieVerlopen(fout) {
    return typeof fout === 'string' && fout === SESSIE_VERLOPEN;
}

/** Een melding waar iemand iets aan heeft, wat er ook binnenkomt. */
function tekstVan(fout) {
    if (typeof fout === 'string' && fout.trim() !== '') {
        return fout;
    }

    return 'Geen verbinding met de server. Controleer je verbinding en probeer het opnieuw.';
}
